module.exports = __webpack_public_path__ + "static/img/yuli_add.1ef01b60.png";